var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHospital(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 42,
    viewBox: "0 0 40 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.75 31.5C10.34 31.5 10 31.16 10 30.75V14.75C10 11.73 11.73 10 14.75 10H24.75C27.77 10 29.5 11.73 29.5 14.75V30.75C29.5 31.16 29.16 31.5 28.75 31.5H10.75ZM28 30V14.75C28 12.53 26.97 11.5 24.75 11.5H14.75C12.53 11.5 11.5 12.53 11.5 14.75V30H28Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.87345 31.8795C9.45826 31.8795 9.11395 31.5354 9.11395 31.1205C9.11395 30.7055 9.45826 30.3615 9.87345 30.3615H30.1266C30.5418 30.3615 30.8861 30.7055 30.8861 31.1205C30.8861 31.5354 30.5418 31.8795 30.1266 31.8795H9.87345Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.962 31.8795C16.5468 31.8795 16.2025 31.5354 16.2025 31.1205V24.9875C16.2025 24.0463 16.9721 23.2771 17.9139 23.2771H22.0962C23.038 23.2771 23.8076 24.0463 23.8076 24.9875V31.1205C23.7974 31.5354 23.4531 31.8795 23.038 31.8795H16.962ZM22.2785 30.3615V24.9875C22.2785 24.8863 22.1974 24.7952 22.0861 24.7952H17.9038C17.8025 24.7952 17.7114 24.8762 17.7114 24.9875V30.3615H17.7215H22.2785Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHospital);
export default __webpack_public_path__ + "static/media/hospital.29bf8aeb21a0cec6b0f71c4aea32a4d5.svg";
export { ForwardRef as ReactComponent };